import Vue from 'vue'
import api from '@/api_alv'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'

const DIR = 'publishing/releases'
const DEFAULT_RELEASE = {
    "id": 0,
    "alvId": "ALV000000000PR",
    "title": null,
    "tag": null,
    "note": null,
    "sheets": [],
    "productionTypeId": null,
    "producer": null,
    "tvStation": null,
    "favourites": "no"
}

const state = {
// List
    publishingProjects: [],
    selectedPublishingProjects: [],
    isAllSelectedPublishingProjects: false,
    expandedPublishingProjects: [],
    publishingProjectsDetailsSelectedCompany:[],
    selectedMoveProjects: [],

// Filters
    publishingProjectsSearch: '',

// Actions (Buttons, Import, Export)
    // showDeletionDialogSelectedPublishingProjects: false,
    selectedPublishingProjectsAction: [],
    publishingProjectsImportTags: "",
    publishingProjectsImportSelectedMapping: null,

// Details (Edit Form + Read Only)
    defaultNewPublishingProjects: DEFAULT_RELEASE,
    publishingProjectsDetails: {},
    publishingProjectsUniqueId: '',   
    // Dropdowns 
    publishingProjectsProducerOptions: [],
    publishingProjectsProductionTypeOptions: [],   
    
    // Sheets Panel
    projectsSheets:[],
    projectsSheetSearch:'',
    selectedProjectsSheet: [],
    totalProjectsSheetListed: null,
}

const getters = {
// List    
    getPublishingProjects(state)                            { return state.publishingProjects },
    getSelectedPublishingProjects(state)                    { return state.selectedPublishingProjects },
    getIsAllSelectedPublishingProjects(state)               { return state.isAllSelectedPublishingProjects },
    getExpandedPublishingProjects(state)                    { return state.expandedPublishingProjects },
    getPublishingProjectsDetailsSelectedCompany(state)      { return state.publishingProjectsDetailsSelectedCompany },

// Filters
    getPublishingProjectsSearch(state) { return state.publishingProjectsSearch },

// Actions (Buttons, Import, Export)
    // getShowDeletionDialogSelectedPublishingProjects(state) { return state.showDeletionDialogSelectedPublishingProjects },
    getSelectedPublishingProjectsAction(state) { return state.selectedPublishingProjectsAction },
    // Import (Mapping)
    getPublishingProjectsDetailsImportTags(state) { return state.publishingProjectsImportTags },
    getPublishingProjectsDetailsImportSelectedMapping(state) { return state.publishingProjectsImportSelectedMapping },

// Details (Edit Form + Read Only)
    getDefaultNewPublishingProjects(state) { return state.defaultNewPublishingProjects },
    getPublishingProjectsUniqueId(state) { return state.publishingProjectsUniqueId },
    getPublishingProjectsDetails(state) { return state.publishingProjectsDetails },    
    // Edit Form Fields    
    getPublishingProjectsDetailsTitle(state) { return state.publishingProjectsDetails.title },
    getPublishingProjectsDetailsAlvId(state) { return state.publishingProjectsDetails.alvId },
    getPublishingProjectsDetailsTag(state) { return state.publishingProjectsDetails.tag },
    getPublishingProjectsDetailsNote(state) { return state.publishingProjectsDetails.note },
    getPublishingProjectsDetailsProducer(state) { return state.publishingProjectsDetails.producer },
    getPublishingProjectsProducerOptions(state) {return state.publishingProjectsProducerOptions },
    getPublishingProjectsDetailsProductionTypeId(state) { return state.publishingProjectsDetails.productionTypeId },
    getPublishingProjectsProductionTypeOptions(state) { return state.publishingProjectsProductionTypeOptions },
    getPublishingProjectsDetailsTvStation(state) { return state.publishingProjectsDetails.tvStation },
    getPublishingProjectsDetailsFavourite(state) { return state.publishingProjectsDetails.favourites },

    //Sheets panel
    getProjectsSheets(state) { return state.projectsSheets },
    getProjectsSheetSearch(state) { return state.projectsSheetSearch },
    getSelectedProjectsSheet(state) { return state.selectedProjectsSheet },
    getTotalProjectsSheetListed(state) { return state.totalProjectsSheetListed },
}

const mutations = {
// List
    setPublishingProjects:                                  (state, value) => { state.publishingProjects = value },
    setSelectedPublishingProjects:                          (state, value) => { state.selectedPublishingProjects = value },
    setIsAllSelectedPublishingProjects:                     (state, value) => { state.isAllSelectedPublishingProjects = value },
    setExpandedPublishingProjects:                          (state, release) => { 
        if(Object.keys(release).length === 0) state.expandedPublishingProjects = []
        else state.expandedPublishingProjects.push(release) },
    setPublishingProjectsDetailsSelectedCompany:            (state, value) => { state.publishingProjectsDetailsSelectedCompany = value },

// Filters
    setPublishingProjectsSearch: (state, search) => { state.publishingProjectsSearch = search },

// Actions (Buttons, Import, Export)
    // setShowDeletionDialogSelectedPublishingProjects: (state, show) => { state.showDeletionDialogSelectedPublishingProjects = show },
    setSelectedPublishingProjectsAction: (state, action) => { state.selectedPublishingProjectsAction = action },
    // Import (Mapping)
    setPublishingProjectsDetailsImportTags: (state, value) => { state.publishingProjectsImportTags = value },
    setPublishingProjectsDetailsImportSelectedMapping: (state, value) => { state.publishingProjectsImportSelectedMapping = value },

// Details (Edit Form + Read Only)
    setDefaultNewPublishingRelease(state) { state.defaultNewPublishingRelease = DEFAULT_RELEASE },
    setPublishingProjectsUniqueId: (state, uniqueId) => { state.publishingProjectsUniqueId = uniqueId },
    setPublishingProjectsDetails: (state, details) => { state.publishingProjectsDetails = details },
    // Edit Form Fields  
    setPublishingProjectsDetailsTitle: (state, title) => { state.publishingProjectsDetails.title = title },
    setPublishingProjectsDetailsAlvId: (state, alvId) => { state.publishingProjectsDetails.alvId = alvId },
    setPublishingProjectsDetailsTag: (state, tag) => { state.publishingProjectsDetails.tag = tag },
    setPublishingProjectsDetailsNote: (state, note) => { state.publishingProjectsDetails.note = note },
    setPublishingProjectsDetailsProducer: (state, producer) => { state.publishingProjectsDetails.producer = producer },
    setPublishingProjectsProducerOptions: (state, options) => { state.publishingProjectsProducerOptions = options },
    setPublishingProjectsDetailsProductionTypeId: (state, type) => { state.publishingProjectsDetails.productionTypeId = type },
    setPublishingProjectsProductionTypeOptions: (state, options) => { state.publishingProjectsProductionTypeOptions = options },
    setPublishingProjectsDetailsTvStation: (state, name) => { state.publishingProjectsDetails.tvStation = name },
    setPublishingProjectsDetailsFavourite: (state, value) => { state.publishingProjectsDetails.favourites = value },

    // Sheets Panel
    setProjectsSheets: (state, value) => { state.projectsSheets = value },
    setProjectsSheetSearch: (state, value) => { state.projectsSheetSearch = value },
    setSelectedProjectsSheet: (state, value) => { state.selectedProjectsSheet = value },
    setTotalProjectsSheetListed: (state, value) => { state.totalProjectsSheetListed = value },
}

const actions = {
// FETCH PUBLISHING RELEASES LIST
    async fetchPublishingProjects({ commit, getters }) {
        commit('setIsLoading', true)

        // check for set filters
        let filterObj = {
            'search' : getters.getPublishingProjectsSearch
        }
        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)
        

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPublishingProjects', [])   
        } else {
            commit('setPublishingProjects', response.list)   
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },

// FETCH DETAILS
    async fetchPublishingProjectsDetails({ commit, dispatch, getters }, alvId) {
        let values
        // let currentPage = router.currentRoute.name

        if(alvId === 'new') {
            let defaultValues = JSON.parse(JSON.stringify(getters.getDefaultNewPublishingProjects)) 
            values = defaultValues
        } else {
            let response = await api.getDetailsById(DIR, alvId)
            if(response === undefined || response.length === 0 || response.error === 1) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: 'Daten konnten nicht oder nur unvollständig geladen werden'
                })
            } else values = response
        }
        
        commit('setPublishingProjectsDetails', values)
        if(alvId !== 'new') dispatch('fetchProjectsSheets')
        else commit('setProjectsSheets', [])
        // if(currentPage.substr(currentPage.length - 4) === 'Edit') dispatch('fetchPublishingProjectsDropdownValues')
        commit('setIsLoading', false)
    },

    async fetchAutocompletePublishingProjectsProducer({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input, 'type=producer')
        commit('setPublishingProjectsProducerOptions', response.list)
    },

    async fetchPublishingReleaseDropdownValues({ commit }) {
        let items = await api.getDropdownValues(DIR, 'productionTypes')
       items.forEach(element => {        
           let langConst = element.header
           element.header = i18n.t(langConst)
       });
        commit('setPublishingReleaseProductionTypeOptions', items)
    },

    async savePublishingProjectsForm({ commit, getters, dispatch }) {
        let alvId = getters.getPublishingProjectsDetailsAlvId
        let metaData = getters.getPublishingProjectsDetails
        let isNew = router.currentRoute.params.alvId == "new"

        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        if(response === undefined || response.length === 0 || response.error === 1) {
            response = []
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_MESSAGE_ERROR_SAVING_FAILED')
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_PUBLISHING_PROJECTS_SNACKBAR_PROJECT_SAVED')
            })

            if(isNew) {
                router.push( { name: 'PublishingProjectsEdit', params: { alvId: response.response.alvId }} )
            }

            // refresh data
            await dispatch('fetchPublishingProjectsDetails', response.response.alvId)
        }
    },

    // ACTIONS Switch
    async doPublishingProjectsAction({ commit, getters }) {
        let selectedProjects = getters.getSelectedPublishingProjects; // Fetch selected projects
        if (selectedProjects.length > 0) {
            switch (getters.getSelectedPublishingProjectsAction) {
                case 'move':
                    if(state.selectedPublishingProjects.length > 0) {
                        commit('setShowMoveContractsDialog',true)
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true)	
                    }
                    break
                case 'delete':
                    commit('setShowDeletionDialog', true); // Reuse the deletion dialog mutation
                    break;
                default:
                    commit('setSnackbar', {
                        type: 'error',
                        msg: 'Unsupported action selected.',
                    });
            }
        } else {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE'); 
            commit('setShowSelectionRequiredDialog', true);
        }
    },

    //Action : MOVE
    async moveSelectedPublishingProjects({ getters, commit, dispatch  }) {

        let metaData = { "alvIds" : getters.getSelectedPublishingProjects,
        
                        "company" : getters.getPublishingProjectsDetailsSelectedCompany }
        let queryParams = { "action": 'move'}
        const response = await api.triggerAction(DIR,metaData,queryParams)


        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_MOVED')
            })
        }
        
        commit('setSelectedPublishingProjects', [])
        commit("setIsAllSelectedPublishingProjects",false)
        commit('setSelectedPublishingProjectsAction', [])
        dispatch('fetchPublishingProjects')
    },

    // Action: DELETE
    async deleteSelectedPublishingProjects({ commit, getters, dispatch }) {  
        let selectedReleases = getters.getSelectedPublishingProjects
        let releases = getters.getPublishingProjects

        const response = await api.deleteEntries(DIR, selectedReleases)

        if(response.error === -1) {        
            for(let i = 0; i < selectedReleases.length; i++) {
                let index = releases.findIndex(release => release.alvId == selectedReleases[i])
                Vue.delete(releases, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
            
            commit('setSelectedPublishingProjects', [])
            commit('setSelectedPublishingProjectsAction', [])
            dispatch('fetchPublishingProjects')
        }
    },
        //Sheets Panel
    
    async searchProjectsSheet({ getters }){
        let existingSheetsAlvIds = getters.getProjectsSheets.map(sheet => sheet.alvId)
        let params = "search=" + getters.getProjectsSheetSearch
        // 24.02.2025: do not send excluded-ALVIDs as part of URL (too many), for https://alvdigital.atlassian.net/browse/ALVSERVICE-1745
        // if(existingSheetsAlvIds) params += '&excludeAlvIds=' + existingSheetsAlvIds.join(",")

        let response = await api.getFilteredResults("publishing/sheets",params)

        return response.list   
    },

    async addSheetToProjects({ getters, commit }, selectedItems){
        let sheets = getters.getProjectsSheets
        let startSheetAmount = sheets.length

        for (let i = 0; i < selectedItems.length; i++) {
            sheets.push(selectedItems[i])
        }
        
        let newSheetsAmount = sheets.length

        if(newSheetsAmount > startSheetAmount ){
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERAL_SNACKBAR_ADDED_SUCCESSFULLY') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON')
            })
        }

    },

        // Sheets Panel
        async fetchProjectsSheets({ commit, getters }) {
        
        let sheets = getters.getPublishingProjectsDetails.sheets

        if(sheets === undefined || sheets === null) return []
        else {
            if(sheets.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
            commit('setProjectsSheets', sheets)
        }

        commit('setIsLoading', false)
    },
    
    async deleteSelectedProjectsSheet({commit, getters}){
        let selectedSheet = getters.getSelectedProjectsSheet[0]
        let selectedSheetAlvId = selectedSheet.alvId
        let connectedSheets = getters.getProjectsSheets
        let index = connectedSheets.findIndex(sheet => sheet.alvId === selectedSheetAlvId)

        let startSheetsAmount = getters.getProjectsSheets.length
        Vue.delete(connectedSheets, index)
        let newSheetsAmount = getters.getProjectsSheets.length

        if(startSheetsAmount > newSheetsAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedProjectsSheet', [])
        if(newSheetsAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    }
}

export default { state, getters, actions, mutations }